/* eslint-disable */
import React from "react";

const ChallengeActivityBox = ({
  joinedChallenge,
  userProgress,
  daysLeft,
  totalScore,
  topScores,
  userName,
  openViewScoresModal,
}) => {
  return (
    <div
      className={`challenge-how-it-works-box ${
        joinedChallenge ? "logged-in" : "public"
      }`}
      style={{ padding: "0px" }}
    >
      <div style={{ padding: "30px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <h3 style={{ fontSize: "20px", fontWeight: "600", margin: 0 }}>
            Your activity
          </h3>
          <div>
            <div
              style={{
                textAlign: "right",
                marginBottom: "5px",
                fontSize: "14px",
                color: "#666",
              }}
            >
              {userProgress} of 3 scores posted • {daysLeft} days left
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "2px",
                width: "220px",
              }}
            >
              <div
                style={{
                  width: "33.3%",
                  height: "7px",
                  backgroundColor: userProgress >= 1 ? "#00365F" : "#E0E0E0",
                  borderTopLeftRadius: "5px",
                  borderBottomLeftRadius: "5px",
                  backgroundClip: "content-box",
                }}
              ></div>

              <div
                style={{
                  width: "33.3%",
                  height: "7px",
                  backgroundColor: userProgress >= 2 ? "#00365F" : "#E0E0E0",
                  borderRadius: "0px",
                }}
              ></div>

              <div
                style={{
                  width: "33.3%",
                  height: "7px",
                  backgroundColor: userProgress >= 3 ? "#00365F" : "#E0E0E0",
                  borderTopRightRadius: "5px",
                  borderBottomRightRadius: "5px",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ paddingTop: "10px" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "14px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          <thead>
            <tr
              style={{
                borderBottom: "1px solid #E0E0E0",
                color: "#475467",
                fontSize: "16px",
              }}
            >
              <th style={{ paddingBottom: "2px " }} />
              <th style={{ width: "10%" }}>TOTAL</th>
              <th style={{ width: "10%" }}>R1</th>
              <th style={{ width: "10%" }}>R2</th>
              <th style={{ width: "10%" }}>R3</th>
            </tr>
          </thead>
          <tbody>
            <tr
              style={{
                backgroundColor: "rgba(0, 54, 95, 0.10)",
                fontSize: "18px",
                fontWeight: "500",
                height: "44px",
              }}
            >
              <td
                style={{
                  paddingLeft: "30px",
                  verticalAlign: "middle",
                  textAlign: "left",
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                {userName}
              </td>
              <td
                style={{
                  padding: "10px",
                  verticalAlign: "middle",
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                {totalScore}
              </td>
              <td
                style={{
                  padding: "10px",
                  verticalAlign: "middle",
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                {topScores[0] && topScores[0].net_to_par}
              </td>
              <td
                style={{
                  padding: "10px",
                  verticalAlign: "middle",
                  borderRight: "1px solid #E0E0E0",
                }}
              >
                {topScores[1] && topScores[1].net_to_par}
              </td>
              <td style={{ padding: "10px", verticalAlign: "middle" }}>
                {topScores[2] && topScores[2].net_to_par}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="join-button-container" style={{ margin: "auto" }}>
        <div
          className="share-row"
          onClick={openViewScoresModal}
          style={{ cursor: "pointer" }}
        >
          <div
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#00365F",
            }}
          >
            VIEW SCORE DETAILS
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeActivityBox;
